import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

/**
 * 
 * @param {*} id 
 * 
 * Load tier will got data like thisํ
 * {
 *   "data":
 *      {"id":"tier-606142f6f9a0d79dc76defd3",
 *       "name":"New","level":0,
 *       "conditions":[{"value":0,"condition_id":"cond-5172a0135d01a253b2b965ce"}],
 *       "privileges":[{
      "condition": {
        "value": 1000,
        "condition_id": "xxxxxx-5902ca0b0257bb14df426921"
      },
      "item": {
        "value": 10000,
        "coupon_id": "xxxxxx-5902ca0b0257bb14df426921"
      }
    }], 
 * "image_url":"https://bifrost.sandbox.wegiv.co/tier/new.png",...
 * Then load privileges info and condition
 * Currently API can't load getOne on coupons and condition so need to load all to check by itself
 * 
 * 
 * tier data example
 * [{ condition: {
              value: 100,
              message: "Buy more than %d units",
              id: "xxxx-12312313213",
              type: "[item_qty] >= [value]",
            },
            coupon: {
              value: 20,
              message: "Discount",
              id: "xxxx-12312313213",
              type: "Discount",
            }, 
          }]
 * 
 * @returns { tiers, loading, error };
 */
export default function useTierInfo() {
  const [tiers, setTiers] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const tiers = await dataProvider.getList("member-tiers", {});
        setTiers(tiers.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { tiers, loading, error };
}
